import Image from '../Image'

function ResponseImage( { image } ) {
  if ( !image?.objectKey ) {
    return null
  }

  return (
    <Image
      src={ null }
      objectKey={ `responses-private/${ image.objectKey }` }
      alt=""
      layout="fill"
      objectFit="cover"
    />
  )
}

export default ResponseImage
